import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Header.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <img src="/ArrasLogo.svg" alt="Arras Logo" className="logo" />
        </div>
        <div className="header-text">
          <h1>{t('header.title')}</h1>
          <p className="subtitle">{t('header.subtitle')}</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
